/**
 * Thai translations, keyed by the English source string. Missing keys fall back
 * to English automatically (see i18n.ts). Keep keys byte-identical to the code.
 */
export const TH: Record<string, string> = {
  // --- app / onboarding ---
  "Space Adventura": "สเปซ แอดเวนทูรา",
  "A slow-burn space mining adventure. First — what should we call you, Captain?":
    "การผจญภัยขุดแร่ในอวกาศแบบค่อยเป็นค่อยไป ก่อนอื่น — เราควรเรียกคุณว่าอะไรดี กัปตัน?",
  "Enter your name": "กรอกชื่อของคุณ",
  "Begin": "เริ่ม",
  "Back": "ย้อนกลับ",
  "Next": "ถัดไป",
  "Launch": "ออกเดินทาง",
  "Skip guide": "ข้ามคู่มือ",
  // --- main menu ---
  "▶  PLAY": "▶  เล่น",
  "Mine · Upgrade · Conquer deep space": "ขุดแร่ · อัพเกรด · พิชิตห้วงอวกาศลึก",
  "LIVE — late-game preview": "สด — ตัวอย่างช่วงท้ายเกม",
  // --- auth / account ---
  "Log In": "เข้าสู่ระบบ",
  "Register": "สมัครสมาชิก",
  "Username": "ชื่อผู้ใช้",
  "Password": "รหัสผ่าน",
  "Create Account": "สร้างบัญชี",
  "Please wait…": "กรุณารอสักครู่…",
  "New pilot? Switch to Register.": "นักบินใหม่? สลับไปที่สมัครสมาชิก",
  "Already have an account? Switch to Log In.": "มีบัญชีอยู่แล้ว? สลับไปที่เข้าสู่ระบบ",
  "Online play isn't configured yet — add your Supabase URL and anon key to .env, then restart.":
    "ยังไม่ได้ตั้งค่าการเล่นออนไลน์ — เพิ่ม Supabase URL และ anon key ลงใน .env แล้วรีสตาร์ท",
  "Players online": "ผู้เล่นออนไลน์",
  "Signed in as": "เข้าสู่ระบบในชื่อ",
  "Log out": "ออกจากระบบ",
  "Main menu": "เมนูหลัก",
  // --- hub ---
  "Enter Hub": "เข้าสู่ฮับ",
  "Central Hub": "ฮับกลาง",
  "Reach Mk II to join the Hub": "ต้องถึง Mk II เพื่อเข้าฮับ",
  "Hub is in testing": "ฮับอยู่ระหว่างการทดสอบ",
  "Hub is in testing — things may change or break": "ฮับอยู่ระหว่างการทดสอบ — อาจมีการเปลี่ยนแปลงหรือขัดข้อง",
  "Server": "เซิร์ฟเวอร์",
  "Pilots here": "นักบินที่นี่",
  "you": "คุณ",
  "Tap to fly — no combat between pilots here": "แตะเพื่อบิน — ไม่มีการต่อสู้ระหว่างนักบินที่นี่",
  // onboarding step titles
  "Mine the belt": "ขุดแร่ในแถบดาวเคราะห์น้อย",
  "Grow your ship": "พัฒนายานของคุณ",
  "Planets & services": "ดาวเคราะห์และบริการ",
  "Defend yourself": "ป้องกันตัวเอง",
  "Navigate & warp": "นำทางและวาร์ป",
  "Where to start": "เริ่มจากตรงไหนดี",
  // onboarding step bodies
  "You command a mining Carrier. Tap an asteroid to fly over and mine it with your hull lasers — richer rocks give more minerals and XP. Tap empty space to move.":
    "คุณบังคับยานขุดแร่ แตะที่ดาวเคราะห์น้อยเพื่อบินไปขุดด้วยเลเซอร์ของยาน — ก้อนที่อุดมสมบูรณ์กว่าให้แร่และค่าประสบการณ์มากกว่า แตะที่ว่างเพื่อเคลื่อนที่",
  "Spend minerals in the Upgrades tree to boost mining, range and speed. Refit to Mk II at a mechanical yard to unlock Drones, then push on to Mk III and the Mk IV Carrier.":
    "ใช้แร่ในหน้าอัพเกรดเพื่อเพิ่มการขุด ระยะ และความเร็ว ไปอัพเกรดเป็น Mk II ที่อู่ซ่อมเพื่อปลดล็อกโดรน แล้วไปต่อที่ Mk III และยานบรรทุก Mk IV",
  "Leave a planet to fly the solar system. 🛒 Trade hubs swap minerals for Units; 🔧 Mechanical yards repair, refit and manage your Arsenal; 🍺 Space Taverns recruit crew. These planets are SAFE ZONES.":
    "ออกจากดาวเพื่อบินสำรวจระบบสุริยะ 🛒 ศูนย์การค้าแลกแร่เป็นหน่วยเงิน (Units); 🔧 อู่ซ่อมซ่อมแซม อัพเกรด และจัดการคลังอาวุธ; 🍺 โรงเตี๊ยมอวกาศจ้างลูกเรือ ดาวเหล่านี้เป็นเขตปลอดภัย",
  "Hostile Fighters make fast strafing runs, firing red bolts. Refit to Mk II to mount turrets that auto-target them. Mining pauses during combat — watch your ⛉ shield and ❤ hull.":
    "ยานรบศัตรูจะพุ่งเข้าโจมตีอย่างรวดเร็วพร้อมยิงกระสุนสีแดง อัพเกรดเป็น Mk II เพื่อติดป้อมปืนที่เล็งเป้าอัตโนมัติ การขุดจะหยุดระหว่างการต่อสู้ — ระวังโล่ ⛉ และเกราะ ❤ ของคุณ",
  "The view stays zoomed out, so use the top-right minimap: green dots are asteroids, purple moons, blue the planet, red enemies — yellow is you. Craft Warp Fuel to jump to a richer system.":
    "มุมมองจะซูมออก จึงควรใช้แผนที่ย่อมุมขวาบน: จุดเขียวคือดาวเคราะห์น้อย ม่วงคือดวงจันทร์ น้ำเงินคือดาวเคราะห์ แดงคือศัตรู — เหลืองคือคุณ คราฟต์เชื้อเพลิงวาร์ปเพื่อกระโดดไปยังระบบที่อุดมสมบูรณ์กว่า",
  "Head to the nearest asteroids and mine until you can afford your first upgrades. Build toward the Mk II refit at a 🔧 mechanical planet to unlock drones and turrets. Good luck, Captain!":
    "มุ่งหน้าไปยังดาวเคราะห์น้อยที่ใกล้ที่สุดแล้วขุดจนกว่าจะซื้ออัพเกรดแรกได้ สะสมเพื่ออัพเกรดเป็น Mk II ที่ดาว 🔧 เพื่อปลดล็อกโดรนและป้อมปืน ขอให้โชคดี กัปตัน!",

  // --- HUD stats / labels ---
  Minerals: "แร่",
  Units: "หน่วยเงิน",
  Drones: "โดรน",
  Bodies: "วัตถุ",
  Planets: "ดาวเคราะห์",
  Map: "แผนที่",
  Jumps: "การกระโดด",
  "Dark Matter": "สสารมืด",
  "⛉ Shield": "⛉ โล่",
  "❤ Hull": "❤ เกราะ",
  System: "ระบบสุริยะ",
  Planet: "ดาวเคราะห์",
  mining: "กำลังขุด",
  Locked: "ล็อกอยู่",
  AUTO: "อัตโนมัติ",
  "tap target": "แตะเป้าหมาย",
  LOCKED: "ล็อกเป้า",
  "Launch a homing-missile salvo": "ยิงชุดจรวดนำวิถี",

  // --- menu ---
  Menu: "เมนู",
  "Reset progress": "รีเซ็ตความคืบหน้า",
  Language: "ภาษา",
  "Reset ALL progress? This cannot be undone.":
    "รีเซ็ตความคืบหน้าทั้งหมด? การกระทำนี้ย้อนกลับไม่ได้",

  // --- bottom bar ---
  "Leave Planet": "ออกจากดาว",
  Services: "บริการ",
  Trade: "การค้า",
  Tavern: "โรงเตี๊ยม",
  Upgrades: "อัพเกรด",
  Stats: "สถานะ",
  Items: "ไอเทม",
  Range: "ระยะ",
  Warp: "วาร์ป",
  "⚔ In combat — mining lasers & drones are offline until the fighters are down":
    "⚔ อยู่ในการต่อสู้ — เลเซอร์ขุดและโดรนจะหยุดจนกว่าจะกำจัดยานรบได้",
  "⛏ Flying in to mine — tap the target again to stop · tap space to fly":
    "⛏ กำลังบินเข้าไปขุด — แตะเป้าหมายอีกครั้งเพื่อหยุด · แตะที่ว่างเพื่อบิน",
  "Tap an asteroid to mine it · drones auto-mine nearby rocks":
    "แตะดาวเคราะห์น้อยเพื่อขุด · โดรนจะขุดก้อนใกล้ ๆ ให้อัตโนมัติ",
  "Tap an asteroid to fly over and mine it · tap empty space to move":
    "แตะดาวเคราะห์น้อยเพื่อบินไปขุด · แตะที่ว่างเพื่อเคลื่อนที่",
  "Tap a planet to travel to it · tap empty space to explore the system":
    "แตะดาวเคราะห์เพื่อเดินทางไป · แตะที่ว่างเพื่อสำรวจระบบ",
  "Fly up to the 🔧 mechanical planet to use its services":
    "บินเข้าไปที่ดาว 🔧 อู่ซ่อม เพื่อใช้บริการ",
  "Fly up to the 🍺 Space Tavern to use its services":
    "บินเข้าไปที่ 🍺 โรงเตี๊ยมอวกาศ เพื่อใช้บริการ",
  "Fly up to the 🛒 trade-hub to use its services":
    "บินเข้าไปที่ 🛒 ศูนย์การค้า เพื่อใช้บริการ",
  "Consumes 1 Warp Drive Fuel": "ใช้เชื้อเพลิงวาร์ป 1 หน่วย",

  // --- death / respawn ---
  "SHIP DESTROYED": "ยานถูกทำลาย",
  "Your Carrier was lost. Rebuild and jump back to the system — your upgrades, crew and cargo bays remain.":
    "ยานของคุณถูกทำลาย สร้างใหม่แล้วกระโดดกลับสู่ระบบ — อัพเกรด ลูกเรือ และช่องเก็บของยังคงอยู่",
  "Respawn": "เกิดใหม่",

  // --- mechanical yard / services ---
  "Mechanical Yard": "อู่ซ่อมยาน",
  Hull: "เกราะ",
  Shield: "โล่",
  "Upgrade Mothership": "อัพเกรดยานแม่",
  "Hull Refit": "เปลี่ยนตัวถังยาน",
  ready: "พร้อม",
  "Repair Hull": "ซ่อมเกราะ",
  full: "เต็ม",
  "Manage Shield Generator": "จัดการเครื่องกำเนิดโล่",
  Crafting: "คราฟต์",
  Arsenal: "คลังอาวุธ",
  "Requires the Mk II hull": "ต้องใช้ตัวถัง Mk II",

  // --- hull refit ---
  "Top hull reached": "ถึงตัวถังสูงสุดแล้ว",
  "The Battleship is the heaviest hull available.":
    "เรือรบคือตัวถังที่หนักที่สุดที่มี",
  Cost: "ราคา",
  CURRENT: "ปัจจุบัน",
  NEXT: "ถัดไป",
  MAX: "สูงสุด",
  "Dock at a 🔧 mechanical yard to refit.": "จอดที่อู่ซ่อม 🔧 เพื่ออัพเกรด",
  "Buy the prerequisite upgrades first (see the ⚙ Upgrades tree).":
    "ซื้ออัพเกรดที่จำเป็นก่อน (ดูที่หน้าอัพเกรด ⚙)",

  // --- tavern ---
  "Space Tavern": "โรงเตี๊ยมอวกาศ",
  "Crew Recruitment": "จ้างลูกเรือ",
  Upgrade: "อัพเกรด",
  "Miner Drone Controller": "ผู้ควบคุมโดรนขุด",
  "Fighter Pilot": "นักบินรบ",
  "Assign to drones": "มอบหมายให้ควบคุมโดรน",
  Unassign: "ยกเลิก",
  "Assign in Fleet Management": "มอบหมายในหน้าจัดการฝูงบิน",
  "Recruit crew first.": "จ้างลูกเรือก่อน",
  "Max tier": "ระดับสูงสุด",
  Common: "ธรรมดา",
  Rare: "หายาก",
  Epic: "เอปิก",
  Legendary: "เลเจนดารี",
  Tier: "ระดับ",

  // --- arsenal / fleet ---
  Weapons: "อาวุธ",
  "Fleet Management": "จัดการฝูงบิน",
  "Buy Twin Cannon": "ซื้อปืนคู่",
  "Buy Spinal Cannon": "ซื้อปืนใหญ่กลางลำ",
  "Buy Fighter": "ซื้อยานรบ",
  Scrap: "ทิ้ง",
  "Remove pilot": "ปลดนักบิน",
  Equip: "ติดตั้ง",
  Remove: "ถอด",
  Unlock: "ปลดล็อก",
  "Assign pilot…": "มอบหมายนักบิน…",
  Fighters: "ยานรบ",
  deployed: "ออกรบ",

  // --- inventory ---
  Inventory: "คลังของ",
  Mods: "อุปกรณ์เสริม",
  Pilots: "นักบิน",
  GROUNDED: "ยังไม่ได้ออกรบ",
  READY: "พร้อม",
  "K.I.A.": "เสียชีวิต",
  "Killed in action — reroll at a 🍺 tavern to replace.":
    "เสียชีวิตในการรบ — สุ่มใหม่ที่โรงเตี๊ยม 🍺 เพื่อหานักบินคนใหม่",
  Fighters: "ยานรบ",
  flying: "ออกรบ",

  // --- upgrade tree ---
  "Upgrade Tree": "แผนผังอัพเกรด",
  Skill: "สกิล",
  "Energy Cores": "แกนพลังงาน",
  Owned: "มีแล้ว",

  // --- common ---
  Close: "ปิด",
  Buy: "ซื้อ",
  Sell: "ขาย",

  // --- upgrade tree: node names ---
  "Mining Laser I": "เลเซอร์ขุด I",
  "Mining Laser II": "เลเซอร์ขุด II",
  "Mining Laser III": "เลเซอร์ขุด III",
  "Focused Beam Array": "ชุดลำแสงโฟกัส",
  "Focusing Optics I": "เลนส์โฟกัส I",
  "Focusing Optics II": "เลนส์โฟกัส II",
  "Range Amplifier": "ตัวขยายระยะ",
  "Long-Range Lens": "เลนส์ระยะไกล",
  "Deep-Field Optics": "เลนส์สนามลึก",
  "Ion Drive I": "ไอออนไดรฟ์ I",
  "Ion Drive II": "ไอออนไดรฟ์ II",
  "Fusion Thrusters": "เครื่องยนต์ฟิวชัน",
  "Warp Coils": "ขดลวดวาร์ป",
  "Afterburner I": "สันดาปท้าย I",
  "Afterburner II": "สันดาปท้าย II",
  "Solar Sail I": "ใบเรือสุริยะ I",
  "Solar Sail II": "ใบเรือสุริยะ II",
  "Ramscoop Sails": "ใบเรือแรมสคูป",
  "Ore Sorter": "เครื่องคัดแยกแร่",
  "Refinery I": "โรงถลุง I",
  "Refinery II": "โรงถลุง II",
  "Refinery III": "โรงถลุง III",
  "Refinery IV": "โรงถลุง IV",
  "Electro-Refinery": "โรงถลุงไฟฟ้า",
  "Nanite Refinery": "โรงถลุงนาไนต์",
  "Tri-Beam Array": "ชุดลำแสงสาม",
  "Quad-Beam Array": "ชุดลำแสงสี่",
  "Penta-Beam Array": "ชุดลำแสงห้า",
  "Siege Laser": "เลเซอร์ล้อมโจมตี",
  "Mothership Mk II": "ยานแม่ Mk II",
  "Mothership Mk III": "ยานแม่ Mk III",
  "Mothership Mk IV": "ยานแม่ Mk IV",
  "Hangar Bay I": "โรงเก็บยาน I",
  "Hangar Bay II": "โรงเก็บยาน II",
  "Hangar Bay III": "โรงเก็บยาน III",
  "Swarm Command": "บัญชาการฝูงโดรน",
  "Repair Drone Bay": "โรงเก็บโดรนซ่อม",
  "Drone Ion Thrusters": "เครื่องยนต์ไอออนโดรน",
  "Drone Overdrive": "โดรนโอเวอร์ไดรฟ์",
  "Cargo Pods I": "ห้องบรรทุก I",
  "Cargo Pods II": "ห้องบรรทุก II",
  "Cargo Pods III": "ห้องบรรทุก III",
  "Freight Holds": "ห้องเก็บสินค้า",
  "Plasma Drills I": "สว่านพลาสมา I",
  "Plasma Drills II": "สว่านพลาสมา II",
  "Plasma Drills III": "สว่านพลาสมา III",
  "Deploy Range I": "ระยะปล่อยโดรน I",
  "Deploy Range II": "ระยะปล่อยโดรน II",
  "Omni-Mining Array": "ชุดขุดรอบทิศ",
  "Fighter Bay I": "โรงเก็บยานรบ I",
  "Fighter Bay II": "โรงเก็บยานรบ II",
  "Fighter Bay III": "โรงเก็บยานรบ III",
  "Fighter Wing": "กองบินรบ",
  "Repair Drone Bay II": "โรงเก็บโดรนซ่อม II",
  "Repair Drone Bay III": "โรงเก็บโดรนซ่อม III",

  // --- upgrade tree: node descriptions ---
  "Mining speed +25%": "ความเร็วขุด +25%",
  "Mining speed +30%": "ความเร็วขุด +30%",
  "Mining speed +40%": "ความเร็วขุด +40%",
  "Mining range +20%": "ระยะขุด +20%",
  "Mining range +25%": "ระยะขุด +25%",
  "Ship speed +10%": "ความเร็วยาน +10%",
  "Ship speed +20%": "ความเร็วยาน +20%",
  "Ship speed +25%": "ความเร็วยาน +25%",
  "Ship speed +30%": "ความเร็วยาน +30%",
  "Mineral yield +15%": "ผลผลิตแร่ +15%",
  "Mineral yield +20%": "ผลผลิตแร่ +20%",
  "Mineral yield +25%": "ผลผลิตแร่ +25%",
  "Mineral yield +30%": "ผลผลิตแร่ +30%",
  "Mineral yield +35%": "ผลผลิตแร่ +35%",
  "+1 mining beam (mechanical planet)": "+1 ลำแสงขุด (ดาวอู่ซ่อม)",
  "Unlocks drones: +1 drone": "ปลดล็อกโดรน: +1 โดรน",
  "Unlocks mechanical repair drones: they repair the hull for minerals (3 per HP)":
    "ปลดล็อกโดรนซ่อม: ซ่อมเกราะโดยใช้แร่ (3 แร่ต่อ 1 HP)",
  "Drone speed +30%": "ความเร็วโดรน +30%",
  "Drone speed +25%": "ความเร็วโดรน +25%",
  "Drone capacity +30%": "ความจุโดรน +30%",
  "Drone capacity +35%": "ความจุโดรน +35%",
  "Drone capacity +40%": "ความจุโดรน +40%",
  "Drone capacity +50%": "ความจุโดรน +50%",
  "Drone mining +30%": "การขุดของโดรน +30%",
  "Drone mining +35%": "การขุดของโดรน +35%",
  "Drone mining +40%": "การขุดของโดรน +40%",
  "Drone deploy area +40%": "พื้นที่ปล่อยโดรน +40%",
  "Solar-layer flight speed +40%": "ความเร็วบินในระบบสุริยะ +40%",
  "Solar-layer flight speed +50%": "ความเร็วบินในระบบสุริยะ +50%",
  "+1 drone": "+1 โดรน",
  "+2 drones": "+2 โดรน",
  "+2 repair drones": "+2 โดรนซ่อม",
  "Bigger hull: mining +30%, range +20%, speed −30%. Unlocks drone & repair bays.":
    "ตัวถังใหญ่ขึ้น: ขุด +30%, ระยะ +20%, ความเร็ว −30% ปลดล็อกโรงเก็บโดรนและโดรนซ่อม",
  "Capital hull: mining +40%, range +30%, +1 drone, yield +25%, speed −10%.":
    "ตัวถังระดับหลัก: ขุด +40%, ระยะ +30%, +1 โดรน, ผลผลิต +25%, ความเร็ว −10%",
  "Carrier hull (2× size): plows asteroids, 8 turrets + 3 spinal cannons. Mining +30%, +2 drones, speed −50%.":
    "ตัวถังยานบรรทุก (ใหญ่ 2 เท่า): ดันดาวเคราะห์น้อย, ป้อมปืน 8 + ปืนใหญ่กลางลำ 3 ขุด +30%, +2 โดรน, ความเร็ว −50%",
  "Mine a full 360° around the hull (not just the front).":
    "ขุดได้รอบตัวยาน 360° (ไม่ใช่แค่ด้านหน้า)",
  "+1 escort-fighter slot.": "+1 ช่องยานรบคุ้มกัน",
  "+2 escort-fighter slots.": "+2 ช่องยานรบคุ้มกัน",
  "+3 escort-fighter slots (8 total).": "+3 ช่องยานรบคุ้มกัน (รวม 8)",
  "Mine minerals to buy upgrades · reach Mk II to unlock drones, then push on to Mk III":
    "ขุดแร่เพื่อซื้ออัพเกรด · ไปให้ถึง Mk II เพื่อปลดล็อกโดรน แล้วไปต่อที่ Mk III",

  // --- inventory items ---
  "Moon Core": "แกนดวงจันทร์",
  "Energy Core": "แกนพลังงาน",
  "Warp Drive Fuel": "เชื้อเพลิงวาร์ป",
  "Dropped from moons (10%) / sub-moons (5%). Used to craft Energy Cores.":
    "ได้จากดวงจันทร์ (10%) / ดวงจันทร์ย่อย (5%) ใช้คราฟต์แกนพลังงาน",
  "Crafted at a mechanical planet. Required to refit the mothership (Mk II / Mk III).":
    "คราฟต์ที่ดาวอู่ซ่อม ใช้สำหรับอัพเกรดยานแม่ (Mk II / Mk III)",
  "5% drop from destroying any asteroid. Used to craft Warp Drive Fuel.":
    "ดรอป 5% จากการทำลายดาวเคราะห์น้อย ใช้คราฟต์เชื้อเพลิงวาร์ป",
  "Single-use. Consumed by Warp to jump to a new solar system. Craft it or buy it at a market.":
    "ใช้ครั้งเดียว ใช้ตอนวาร์ปเพื่อกระโดดไประบบใหม่ คราฟต์เองหรือซื้อที่ตลาด",
  "No items yet — destroy moons and asteroids to find materials.":
    "ยังไม่มีไอเทม — ทำลายดวงจันทร์และดาวเคราะห์น้อยเพื่อหาวัสดุ",
  "No modifications yet — build shield generators at a 🛒 trade hub (Build Mods).":
    "ยังไม่มีอุปกรณ์เสริม — สร้างเครื่องกำเนิดโล่ที่ 🛒 ศูนย์การค้า (สร้างอุปกรณ์)",
  "No fighters yet — buy fighters at the 🔧 Arsenal (Mk IV), then assign pilots recruited at a 🍺 Space Tavern here.":
    "ยังไม่มียานรบ — ซื้อยานรบที่คลังอาวุธ 🔧 (Mk IV) แล้วมอบหมายนักบินที่จ้างจาก 🍺 โรงเตี๊ยมอวกาศที่นี่",
  EQUIPPED: "ติดตั้งอยู่",
  NEW: "ใหม่",
  "Fighter Bay": "โรงเก็บยานรบ",
  "No pilot — recruit at a 🍺 Space Tavern.": "ไม่มีนักบิน — จ้างที่ 🍺 โรงเตี๊ยมอวกาศ",
  "Shield Generator": "เครื่องกำเนิดโล่",
  "max shield": "โล่สูงสุด",
  tier: "ระดับ",

  // --- stats panel ---
  Progress: "ความคืบหน้า",
  "Hull mining": "การขุดของยาน",
  Ship: "ยาน",
  Speed: "ความเร็ว",
  "Max drones": "โดรนสูงสุด",
  "Deploy range": "ระยะปล่อยโดรน",
  "Drone mining": "การขุดของโดรน",
  Status: "สถานะ",
  "Locked — reach Mk II": "ล็อกอยู่ — ไปให้ถึง Mk II",

  // --- first-run tutorial ---
  "Fly to a highlighted planet — they're safe zones with services. Tap a planet to travel there.":
    "บินไปยังดาวที่ไฮไลต์ไว้ — เป็นเขตปลอดภัยที่มีบริการ แตะที่ดาวเพื่อเดินทางไป",
  "Tap an asteroid to fly over and mine it. Gather 100 minerals for your first upgrade.":
    "แตะดาวเคราะห์น้อยเพื่อบินไปขุด เก็บแร่ให้ได้ 100 เพื่ออัพเกรดชิ้นแรก",
  "Great haul! Open ⚙ Upgrades and buy Mining Laser I — it boosts your mining speed by 25%.":
    "เก็บได้เยอะเลย! เปิด ⚙ อัพเกรด แล้วซื้อ เลเซอร์ขุด I — เพิ่มความเร็วขุด 25%",
  "You reached Level 2 and earned a Skill Point! Open ⚙ Upgrades and buy a ★ node (like Ore Sorter) to spend it.":
    "คุณถึงเลเวล 2 และได้รับแต้มสกิล! เปิด ⚙ อัพเกรด แล้วซื้อโหนดที่มี ★ (เช่น เครื่องคัดแยกแร่) เพื่อใช้แต้ม",

  // --- Tutor questline: dialog + tracker ---
  Aria: "อาเรีย",
  QUEST: "ภารกิจ",
  Formation: "จัดขบวน",
  "▸ tap to continue": "▸ แตะเพื่อไปต่อ",
  "▸ tap to start": "▸ แตะเพื่อเริ่ม",
  "Hello, Commander! I'm Aria, your onboard flight tutor.":
    "สวัสดีค่ะผู้บัญชาการ! ฉันชื่ออาเรีย ผู้ฝึกสอนประจำยานของคุณ",
  "I'll walk you through the basics so you can run this mining fleet like a veteran.":
    "ฉันจะพาคุณเรียนรู้พื้นฐาน เพื่อให้คุณบังคับกองยานขุดแร่ได้อย่างมืออาชีพ",
  "I'll give you a series of short quests. They give no reward — they're only here to teach you the ropes.":
    "ฉันจะมอบภารกิจสั้น ๆ ให้คุณเป็นชุด ภารกิจเหล่านี้ไม่มีรางวัล — มีไว้เพื่อสอนวิธีเล่นเท่านั้น",
  "Follow them and you'll be self-sufficient in no time. Let's begin!":
    "ทำตามไป แล้วคุณจะพึ่งพาตัวเองได้ในไม่ช้า มาเริ่มกันเลย!",
  "That's the end of my lessons, Commander.":
    "นี่คือบทเรียนสุดท้ายแล้วค่ะผู้บัญชาการ",
  "You now know how to mine, upgrade, trade, craft and defend your ship.":
    "ตอนนี้คุณรู้วิธีขุดแร่ อัพเกรด ค้าขาย คราฟต์ และป้องกันยานของคุณแล้ว",
  "The frontier is yours to conquer. Fly safe out there — Aria, signing off!":
    "ดินแดนแห่งนี้รอให้คุณพิชิต เดินทางปลอดภัยนะคะ — อาเรีย ขอตัวก่อน!",
  "Nicely done, Commander! Here's what's next.":
    "ทำได้ดีมากค่ะผู้บัญชาการ! ต่อไปคือสิ่งนี้",

  // quest titles
  "Find Safe Harbor": "หาที่หลบภัย",
  "First Minerals": "แร่ก้อนแรก",
  "First Upgrade": "อัพเกรดแรก",
  "Level Up": "เลื่อนเลเวล",
  "A Little Trade": "ค้าขายเล็กน้อย",
  "Mechanical Yard": "อู่ซ่อม",
  "Third Beam": "ลำแสงที่สาม",
  "Reach Level 2": "ไปให้ถึงเลเวล 2",
  "Get 2 Units at a Trade Hub": "หา 2 Units ที่ศูนย์การค้า",
  "Dock at a Mechanical yard (🔧)": "แวะที่อู่ซ่อม (🔧)",
  "Unlock the Tri-Beam Array at the yard": "ปลดล็อกชุดลำแสงสามที่อู่ซ่อม",
  "Mining and fighting earn XP. Fill the XP bar to reach Level 2.":
    "การขุดและการต่อสู้ได้รับ XP เติมแถบ XP ให้เต็มเพื่อไปถึงเลเวล 2",
  "Every level grants a Skill Point ★ — and some upgrades need those to unlock.":
    "ทุกเลเวลจะให้แต้มสกิล ★ — และบางอัพเกรดต้องใช้แต้มนี้เพื่อปลดล็อก",
  "Pop over to a Trade Hub (the 🛒 planet) and sell a little ore for 2 Units.":
    "แวะไปที่ศูนย์การค้า (ดาว 🛒) แล้วขายแร่เล็กน้อยเพื่อแลก 2 Units",
  "You'll spend those Units on a special upgrade at the mechanical yard.":
    "คุณจะใช้ Units เหล่านั้นกับอัพเกรดพิเศษที่อู่ซ่อม",
  "Now fly to a Mechanical yard — the 🔧 planet.":
    "ทีนี้บินไปที่อู่ซ่อม — ดาว 🔧",
  "Certain upgrades and every hull refit can ONLY be built here at the yard.":
    "อัพเกรดบางอย่างและการปรับปรุงตัวถังทุกครั้งสร้างได้เฉพาะที่อู่ซ่อมนี้เท่านั้น",
  "At the yard, open ⚙ Upgrades and unlock the Tri-Beam Array — a third mining beam.":
    "ที่อู่ซ่อม เปิด ⚙ อัพเกรด แล้วปลดล็อกชุดลำแสงสาม — ลำแสงขุดลำที่สาม",
  "See how it needs Units, a Skill Point and the yard itself? That's how mechanical upgrades work.":
    "เห็นไหมว่ามันต้องใช้ Units แต้มสกิล และตัวอู่ซ่อมเอง? นั่นแหละคือวิธีทำงานของอัพเกรดกลจักร",
  "Toward Mk II": "มุ่งสู่ Mk II",
  "Trade for Units": "ค้าขายหา Units",
  "Moon Cores": "แกนดวงจันทร์",
  "Energy Core": "แกนพลังงาน",
  "Mk II Refit": "ปรับปรุงเป็น Mk II",
  "Turret Mount": "ฐานติดป้อมปืน",
  "Arm Up": "ติดอาวุธ",
  "Lock & Load": "พร้อมรบ",
  "To the Vast Space!": "สู่ห้วงอวกาศอันกว้างใหญ่!",
  "Craft Warp Fuel, then Warp to a new system":
    "คราฟต์เชื้อเพลิงวาร์ป แล้ววาร์ปไปยังระบบใหม่",
  "One final lesson, Commander. At a Mechanical yard, craft Warp Drive Fuel (⛽) from Dark Matter and Units.":
    "บทเรียนสุดท้ายค่ะผู้บัญชาการ ที่อู่ซ่อม คราฟต์เชื้อเพลิงวาร์ป (⛽) จากดาร์กแมตเตอร์และ Units",
  "Then press the Warp ▸ button to jump to a brand-new solar system — richer, tougher and packed with loot.":
    "จากนั้นกดปุ่มวาร์ป ▸ เพื่อกระโดดไปยังระบบสุริยะใหม่เอี่ยม — อุดมสมบูรณ์กว่า ท้าทายกว่า และเต็มไปด้วยของรางวัล",
  "Each jump makes the galaxy more dangerous and more rewarding. This is how you truly grow. Off you go!":
    "การกระโดดแต่ละครั้งทำให้กาแล็กซีอันตรายขึ้นและคุ้มค่าขึ้น นี่คือหนทางเติบโตอย่างแท้จริง ไปได้เลย!",
  "Still short on Moon Cores? The drops can be stubborn.":
    "ยังขาดแกนดวงจันทร์อยู่ใช่ไหม? การดรอปบางทีก็ดื้อรั้น",
  "You can also buy Moon Cores at a Trade Hub for 200 Units each — give that a try!":
    "คุณสามารถซื้อแกนดวงจันทร์ที่ศูนย์การค้าได้เช่นกัน อันละ 200 Units — ลองดูนะคะ!",
  "Commander — long-range scans just flagged ROGUE planets ahead.":
    "ผู้บัญชาการ — เครื่องสแกนระยะไกลเพิ่งตรวจพบดาวโร้กข้างหน้า",
  "Their moons mount auto-turrets that open fire on anyone who drifts close. A red dot on the minimap marks an armed moon.":
    "ดวงจันทร์ของมันติดตั้งป้อมปืนอัตโนมัติที่จะยิงใส่ทุกคนที่เข้าใกล้ จุดแดงบนมินิแมปหมายถึงดวงจันทร์ที่มีอาวุธ",
  "Destroy a moon's turret before you can mine that moon — but the ore out there is worth three times as much. Stay sharp.":
    "ทำลายป้อมปืนของดวงจันทร์ก่อนจึงจะขุดดวงจันทร์นั้นได้ — แต่แร่ที่นั่นมีค่ามากกว่าถึงสามเท่า ระวังตัวด้วย",

  // Aria — Mk V refit briefing
  "Commander — the yard confirms it: you've got the materials for the Mk V refit.":
    "ผู้บัญชาการ — อู่ต่อยานยืนยันแล้ว: คุณมีวัสดุครบสำหรับการปรับปรุงเป็น Mk V",
  "This is a one-way fork. Commit to a hull and the other path seals shut for good.":
    "นี่คือทางแยกที่เลือกได้ครั้งเดียว เมื่อเลือกตัวถังหนึ่งแล้ว อีกเส้นทางจะปิดตายถาวร",
  "The BATTLESHIP is a gun platform — a wall of turrets, twin Big Cannons that reach clean across the field, and a reinforced shield. It gives up the mining laser, so you'll carve ore with your guns.":
    "เรือรบ (BATTLESHIP) คือฐานปืน — ป้อมปืนเรียงราย, ปืนใหญ่ยักษ์คู่ที่ยิงทะลุข้ามสนามรบ และเกราะพลังงานที่แข็งแกร่งขึ้น มันสละเลเซอร์ขุดไป คุณจึงต้องขุดแร่ด้วยปืนแทน",
  "The SWARM-LORD floods the void with fighters and combat drones from wing runways, and can pull them into a spinning defensive ring. Win by numbers.":
    "เจ้าแห่งฝูง (SWARM-LORD) ปล่อยยานรบและโดรนจู่โจมจำนวนมหาศาลจากรันเวย์ที่ปีก และสามารถเรียกพวกมันมาตั้งวงป้องกันหมุนรอบตัวได้ ชนะด้วยจำนวน",
  "Weigh it carefully and pick the hull that suits how you fight — there's no undo.":
    "ชั่งใจให้ดีแล้วเลือกตัวถังที่เข้ากับสไตล์การรบของคุณ — ไม่มีการย้อนกลับ",

  // quest objectives
  "Fly to a highlighted safe-zone planet": "บินไปยังดาวเขตปลอดภัยที่ไฮไลต์ไว้",
  "Mine until you have 100 minerals": "ขุดจนได้แร่ครบ 100",
  "Buy your first upgrade": "ซื้ออัพเกรดชิ้นแรก",
  "Unlock the Mothership Mk II refit": "ปลดล็อกการปรับปรุงยานแม่ Mk II",
  "Get 20 Units at a Trade Hub": "หา 20 Units ที่ศูนย์การค้า",
  "Collect 2 Moon Cores": "เก็บแกนดวงจันทร์ 2 อัน",
  "Craft 1 Energy Core": "คราฟต์แกนพลังงาน 1 อัน",
  "Refit to Mothership Mk II": "ปรับปรุงเป็นยานแม่ Mk II",
  "Unlock a turret slot": "ปลดล็อกช่องป้อมปืน",
  "Buy or craft a turret": "ซื้อหรือคราฟต์ป้อมปืน",
  "Equip the turret into a mount": "ติดตั้งป้อมปืนเข้ากับฐาน",

  // quest give-lines (Tutor explains each quest)
  "First, fly to one of the highlighted safe-zone planets — they're marked on your map and minimap.":
    "อย่างแรก บินไปยังดาวเขตปลอดภัยที่ไฮไลต์ไว้ — มีเครื่องหมายบนแผนที่และมินิแมป",
  "Safe zones have no raiders, so you can mine in peace and dock for services.":
    "เขตปลอดภัยไม่มีโจร คุณจึงขุดแร่ได้อย่างสงบและแวะใช้บริการได้",
  "Now aim at an asteroid to fire your mining laser. Minerals are the lifeblood of your fleet.":
    "ทีนี้เล็งไปที่ดาวเคราะห์น้อยเพื่อยิงเลเซอร์ขุด แร่คือหัวใจของกองยานคุณ",
  "Gather 100 minerals — just enough for your very first upgrade.":
    "เก็บแร่ให้ได้ 100 — พอสำหรับอัพเกรดชิ้นแรกของคุณ",
  "Open the Upgrades panel and buy your first one — Mining Laser I is the perfect start.":
    "เปิดหน้าต่างอัพเกรดแล้วซื้อชิ้นแรก — เลเซอร์ขุด I เหมาะที่จะเริ่ม",
  "Upgrades make you mine faster, fly farther and hit harder. Keep buying them whenever you can.":
    "อัพเกรดทำให้ขุดเร็วขึ้น บินไกลขึ้น และแรงขึ้น ซื้อไว้เรื่อย ๆ เมื่อมีโอกาส",
  "Keep buying upgrades along the Laser, Optics and Engine lines.":
    "ซื้ออัพเกรดต่อไปในสาย เลเซอร์ เลนส์ และเครื่องยนต์",
  "Once those lines are complete, the Mothership Mk II refit unlocks — a far stronger hull.":
    "เมื่อสายเหล่านั้นครบ การปรับปรุงยานแม่ Mk II จะปลดล็อก — ตัวถังที่แข็งแกร่งขึ้นมาก",
  "Dock at a Trade Hub (the 🛒 planet) and sell minerals for Units.":
    "แวะที่ศูนย์การค้า (ดาว 🛒) แล้วขายแร่เพื่อแลก Units",
  "Units are premium currency for turrets, crew and fighters. Trade until you hold 20.":
    "Units เป็นสกุลเงินพิเศษสำหรับป้อมปืน ลูกเรือ และยานรบ ค้าขายจนมีครบ 20",
  "Fly to a moon and mine it down. Moons sometimes drop rare Moon Cores.":
    "บินไปยังดวงจันทร์แล้วขุดมัน ดวงจันทร์บางครั้งดรอปแกนดวงจันทร์หายาก",
  "Moon Cores are prized crafting materials. Collect 2 of them.":
    "แกนดวงจันทร์เป็นวัตถุดิบคราฟต์ล้ำค่า เก็บมาให้ได้ 2 อัน",
  "At a Mechanical yard (the 🔧 planet), craft an Energy Core from your materials.":
    "ที่อู่ซ่อม (ดาว 🔧) คราฟต์แกนพลังงานจากวัตถุดิบของคุณ",
  "Energy Cores power the big hull refits — you'll need one for the Mk II jump.":
    "แกนพลังงานใช้ขับเคลื่อนการปรับปรุงตัวถังใหญ่ — คุณต้องใช้ 1 อันเพื่อข้ามไป Mk II",
  "Now buy the Mothership Mk II refit in the Upgrades panel.":
    "ทีนี้ซื้อการปรับปรุงยานแม่ Mk II ในหน้าต่างอัพเกรด",
  "Mk II is bigger and tougher, and it unlocks weapon hardpoints and drone bays.":
    "Mk II ใหญ่และทนกว่า อีกทั้งปลดล็อกจุดติดอาวุธและโรงเก็บโดรน",
  "At the Mechanical yard, open the Arsenal and unlock a turret mount.":
    "ที่อู่ซ่อม เปิดคลังอาวุธแล้วปลดล็อกฐานป้อมปืน",
  "Hardpoints let you bolt automatic guns onto your hull.":
    "จุดติดอาวุธให้คุณติดปืนอัตโนมัติเข้ากับตัวถัง",
  "Buy a turret from the Arsenal (or craft one from parts).":
    "ซื้อป้อมปืนจากคลังอาวุธ (หรือคราฟต์จากชิ้นส่วน)",
  "A turret auto-targets raiders, so you can keep mining while it fights for you.":
    "ป้อมปืนเล็งโจรอัตโนมัติ คุณจึงขุดแร่ต่อได้ขณะที่มันสู้แทนคุณ",
  "Finally, equip the turret into your unlocked mount.":
    "สุดท้าย ติดตั้งป้อมปืนเข้ากับฐานที่ปลดล็อกไว้",
  "Your Mothership can now defend itself. You're ready for the frontier!":
    "ตอนนี้ยานแม่ของคุณป้องกันตัวเองได้แล้ว คุณพร้อมสำหรับดินแดนใหม่!",
  "Mining rate": "อัตราการขุด",
  "Beam rate": "อัตราลำแสง",
  Beams: "จำนวนลำแสง",
  "Mining range": "ระยะขุด",
  "Ship speed": "ความเร็วยาน",
  "Mineral yield": "ผลผลิตแร่",
  "Drone speed": "ความเร็วโดรน",
  "Drone cargo": "ความจุโดรน",
  "Drone rate": "อัตราขุดโดรน",
  "Drone range": "ระยะโดรน",
  Hangar: "โรงเก็บยาน",
  Level: "เลเวล",
  "Skill Points": "แต้มสกิล",
  "Play time": "เวลาเล่น",

  // --- Mk V / VI / VII node names ---
  "Mk V · Battleship": "Mk V · เรือรบ",
  "Mk V · Swarm-lord": "Mk V · เจ้าแห่งฝูง",
  "Drone Swarm I": "ฝูงโดรน I",
  "Drone Swarm II": "ฝูงโดรน II",
  "Drone Swarm III": "ฝูงโดรน III",
  "Missile Pod I": "แท่นจรวด I",
  "Missile Pod II": "แท่นจรวด II",
  "Missile Pod III": "แท่นจรวด III",
  "Missile Pod IV": "แท่นจรวด IV",
  "Targeting Array I": "ระบบเล็งเป้า I",
  "Targeting Array II": "ระบบเล็งเป้า II",
  "Battleship Thrusters I": "เครื่องยนต์เรือรบ I",
  "Battleship Thrusters II": "เครื่องยนต์เรือรบ II",
  "Reinforced Plating I": "เกราะเสริม I",
  "Reinforced Plating II": "เกราะเสริม II",
  "Mk VI · Battleship": "Mk VI · เรือรบ",
  "Missile Silos I": "ไซโลจรวด I",
  "Missile Silos II": "ไซโลจรวด II",
  "Missile Silos III": "ไซโลจรวด III",
  "Missile Silos IV": "ไซโลจรวด IV",
  "Beam Capacitors I": "ตัวเก็บประจุลำแสง I",
  "Beam Capacitors II": "ตัวเก็บประจุลำแสง II",
  "Beam Capacitors III": "ตัวเก็บประจุลำแสง III",
  "Mk VII · Eater of Worlds": "Mk VII · ผู้กลืนกินโลก",
  "Extra Segments I": "ปล้องเพิ่ม I",
  "Extra Segments II": "ปล้องเพิ่ม II",
  "Extra Segments III": "ปล้องเพิ่ม III",
  "Devouring Missiles I": "จรวดกลืนกิน I",
  "Devouring Missiles II": "จรวดกลืนกิน II",
  "Devouring Missiles III": "จรวดกลืนกิน III",
  "Devouring Missiles IV": "จรวดกลืนกิน IV",
  "Maw Focus I": "พลังลำแสงปาก I",
  "Maw Focus II": "พลังลำแสงปาก II",
  "Maw Focus III": "พลังลำแสงปาก III",
  "Maw Capacitor I": "ตัวเก็บประจุปาก I",
  "Maw Capacitor II": "ตัวเก็บประจุปาก II",
  "Maw Capacitor III": "ตัวเก็บประจุปาก III",
  "Undulation I": "การเลื้อย I",
  "Undulation II": "การเลื้อย II",
  "Undulation III": "การเลื้อย III",
  "Splitting Warheads I": "หัวรบแตกตัว I",
  "Splitting Warheads II": "หัวรบแตกตัว II",
  "Splitting Warheads III": "หัวรบแตกตัว III",
  "Splitting Pods I": "แท่นแตกตัว I",
  "Splitting Pods II": "แท่นแตกตัว II",
  "Splitting Pods III": "แท่นแตกตัว III",
  // --- Mk VI Swarm-lord branch: names ---
  "Mk VI · Swarm-lord": "Mk VI · เจ้าแห่งฝูง",
  "Mk VII · Swarm-lord": "Mk VII · เจ้าแห่งฝูง",
  "Auto-mine: fly to ore & mine, seek the next": "ขุดอัตโนมัติ: บินไปหาแร่แล้วขุด และหาก้อนต่อไป",
  "Auto-mine paused in combat": "ขุดอัตโนมัติหยุดชั่วคราวระหว่างต่อสู้",
  "Rift Swarm — a volley of piercing homing arrows from two rifts":
    "ฝูงจากรอยแยก — ยิงลูกศรนำวิถีทะลุทะลวงจากรอยแยก 2 จุด",
  "The cosmic apex of the Swarm-lord line — a far larger carrier hull (+20% size, +250 shield) with a new mount layout, keeping the full Mk VI swarm arsenal. Refit off the Mk VI Swarm-lord.":
    "จุดสูงสุดแห่งจักรวาลของสายเจ้าแห่งฝูง — เรือบรรทุกที่ใหญ่ขึ้นมาก (+20% ขนาด, โล่ +250) พร้อมผังตำแหน่งอาวุธใหม่ คงคลังอาวุธฝูงครบชุดของ Mk VI รีฟิตต่อจากเจ้าแห่งฝูง Mk VI",
  "Drone Swarm IV": "ฝูงโดรน IV",
  "Drone Swarm V": "ฝูงโดรน V",
  "Drone Swarm VI": "ฝูงโดรน VI",
  "Drone Swarm VII": "ฝูงโดรน VII",
  "Missile Pod V": "แท่นจรวด V",
  "Missile Pod VI": "แท่นจรวด VI",
  "Missile Pod VII": "แท่นจรวด VII",
  "Rapid Salvo I": "ยิงรัว I",
  "Rapid Salvo II": "ยิงรัว II",
  "Rapid Salvo III": "ยิงรัว III",
  "Smart Missiles": "จรวดอัจฉริยะ",
  "Splitting Pods IV": "แท่นแตกตัว IV",
  "Splitting Pods V": "แท่นแตกตัว V",
  "Drone Missiles": "จรวดโดรน",
  "Fighter Wing V": "กองบินรบ V",
  "Fighter Wing VI": "กองบินรบ VI",
  "Wing Missiles": "จรวดปีก",
  "Swarm Thrusters I": "เครื่องยนต์ฝูง I",
  "Swarm Thrusters II": "เครื่องยนต์ฝูง II",

  // --- Mk V / VI / VII node descriptions ---
  // Mk VI Swarm-lord branch descriptions:
  "Bigger Swarm-lord carrier: 4 wing hangars, up to 28 drones, 16 fighters, 11 turrets, 8 cannons, +150 shield. Unlocks the Mk VI branches (wing missiles, drone lances, smart missiles, +40% speed & more). No Big Cannons.":
    "เรือบรรทุกเจ้าแห่งฝูงที่ใหญ่ขึ้น: โรงเก็บที่ปีก 4, โดรนสูงสุด 28, ยานรบ 16, ป้อมปืน 11, ปืนใหญ่ 8, โล่ +150 ปลดล็อกสายอัพเกรด Mk VI (จรวดปีก, หอกโดรน, จรวดอัจฉริยะ, +40% ความเร็ว และอื่นๆ) ไม่มีปืนใหญ่ยักษ์",
  "+3 fighter drones for the swarm.": "+3 โดรนรบให้ฝูง",
  "+3 more fighter drones (18 so far; the Drone Swarm VI–VII nodes raise the cap to 28).":
    "+3 โดรนรบเพิ่ม (รวม 18; โหนดฝูงโดรน VI–VII เพิ่มเพดานเป็น 28)",
  "+4 missiles per salvo (20 total).": "+4 จรวดต่อชุด (รวม 20)",
  "+4 missiles per salvo (24 total).": "+4 จรวดต่อชุด (รวม 24)",
  "+4 missiles per salvo (28 total — the Mk VI cap).": "+4 จรวดต่อชุด (รวม 28 — สูงสุดของ Mk VI)",
  "−15% missile-salvo cooldown.": "ลดคูลดาวน์ชุดจรวด −15%",
  "−15% missile-salvo cooldown (~12s at full stack).": "ลดคูลดาวน์ชุดจรวด −15% (~12 วิ เมื่อสะสมเต็ม)",
  "A missile whose target is destroyed locks onto a new nearest enemy instead of wasting the shot.":
    "จรวดที่เป้าหมายถูกทำลายจะล็อกเป้าศัตรูที่ใกล้ที่สุดตัวใหม่แทนการเสียลูกเปล่า",
  "+5% split chance and +1 branch missile.": "+5% โอกาสแตกตัว และ +1 จรวดแยก",
  "+10% split chance (35% max) and +2 branch missiles (8 max).":
    "+10% โอกาสแตกตัว (สูงสุด 35%) และ +2 จรวดแยก (สูงสุด 8)",
  "+5 fighter drones (23 total).": "+5 โดรนรบ (รวม 23)",
  "+5 fighter drones (28 total — the Mk VI cap).": "+5 โดรนรบ (รวม 28 — สูงสุดของ Mk VI)",
  "Each fighter drone auto-launches a homing missile at the nearest enemy (1 missile, 15s cooldown) — the same missile the escort fighters fire.":
    "โดรนรบแต่ละตัวยิงจรวดนำวิถี 1 ลูกใส่ศัตรูที่ใกล้ที่สุดอัตโนมัติ (คูลดาวน์ 15 วิ) — จรวดแบบเดียวกับที่ยานรบคุ้มกันยิง",
  "+2 escort-fighter bays.": "+2 ช่องยานรบคุ้มกัน",
  "+2 escort-fighter bays (16 total).": "+2 ช่องยานรบคุ้มกัน (รวม 16)",
  "Each escort fighter auto-launches 2 homing missiles at the nearest enemy (15s cooldown).":
    "ยานรบคุ้มกันแต่ละตัวยิงจรวดนำวิถี 2 ลูกใส่ศัตรูที่ใกล้ที่สุดอัตโนมัติ (คูลดาวน์ 15 วิ)",
  "+20% ship speed.": "+20% ความเร็วยาน",
  "+20% ship speed (+40% total).": "+20% ความเร็วยาน (+40% รวม)",
  "Firepower path: 14 turrets, 4 cannons + 2 map-length Big Cannons, 8 fighters. Shoots to mine.":
    "สายพลังยิง: ป้อมปืน 14, ปืนใหญ่ 4 + ปืนใหญ่ยักษ์ยาวข้ามแผนที่ 2, ยานรบ 8 ยิงเพื่อขุดแร่",
  "Swarm path: 12 fighters + 12 fighter drones, 14 turrets, 2 cannons, wing runways + defensive rings.":
    "สายฝูง: ยานรบ 12 + โดรนรบ 12, ป้อมปืน 14, ปืนใหญ่ 2, รันเวย์ที่ปีก + วงป้องกัน",
  "Unlocks fighter drones: +4 (smaller, faster, weaker; buffed by the Fighter Drone Controller).":
    "ปลดล็อกโดรนรบ: +4 (เล็กกว่า เร็วกว่า อ่อนกว่า; เสริมพลังโดยผู้ควบคุมโดรนรบ)",
  "+4 fighter drones (8 total).": "+4 โดรนรบ (รวม 8)",
  "+4 fighter drones (12 total — the swarm cap).": "+4 โดรนรบ (รวม 12 — สูงสุดของฝูง)",
  "Unlocks the homing-missile salvo: +4 missiles per salvo (each chases a different enemy).":
    "ปลดล็อกชุดจรวดนำวิถี: +4 จรวดต่อชุด (แต่ละลูกไล่ศัตรูคนละตัว)",
  "+4 missiles per salvo (8 total).": "+4 จรวดต่อชุด (รวม 8)",
  "+4 missiles per salvo (12 total).": "+4 จรวดต่อชุด (รวม 12)",
  "+4 missiles per salvo (16 total — the Mk V cap).": "+4 จรวดต่อชุด (รวม 16 — สูงสุดของ Mk V)",
  "Turret firing range +10%": "ระยะยิงป้อมปืน +10%",
  "Max hull HP +100": "HP เกราะสูงสุด +100",
  "Bigger Battleship: 18 turrets, 8 cannons, 4 Big Cannons (2 per side), 6 missile silos, +250 shield.":
    "เรือรบใหญ่ขึ้น: ป้อมปืน 18, ปืนใหญ่ 8, ปืนใหญ่ยักษ์ 4 (ข้างละ 2), ไซโลจรวด 6, โล่ +250",
  "Unlocks the homing-missile salvo: +2 missiles (each chases a different enemy).":
    "ปลดล็อกชุดจรวดนำวิถี: +2 จรวด (แต่ละลูกไล่ศัตรูคนละตัว)",
  "+4 missiles per salvo (6 total).": "+4 จรวดต่อชุด (รวม 6)",
  "+4 missiles per salvo (10 total).": "+4 จรวดต่อชุด (รวม 10)",
  "+4 missiles per salvo (14 total — the Mk VI cap).": "+4 จรวดต่อชุด (รวม 14 — สูงสุดของ Mk VI)",
  "Big Cannon beams last 5% longer.": "ลำแสงปืนใหญ่ยักษ์นานขึ้น 5%",
  "Big Cannon beams last another 5% longer.": "ลำแสงปืนใหญ่ยักษ์นานขึ้นอีก 5%",
  "SECRET: become the Eater of Worlds. Mine by passing THROUGH rocks/moons; fire a high-damage maw beam; one turret per segment; no thrusters. Consumes 1 EOW Head, 10 Segments, 1 Tail, 1 Core.":
    "ลับ: กลายเป็นผู้กลืนกินโลก ขุดแร่ด้วยการทะลุผ่านก้อนหิน/ดวงจันทร์; ยิงลำแสงปากพลังสูง; ป้อมปืน 1 กระบอกต่อปล้อง; ไม่มีเครื่องยนต์ ใช้หัว EOW 1, ปล้อง 10, หาง 1, แกน 1",
  "+4 body segments — more turrets and a longer body to graze rocks with.":
    "+4 ปล้อง — ป้อมปืนมากขึ้นและลำตัวยาวขึ้นเพื่อเฉี่ยวก้อนหิน",
  "+4 body segments.": "+4 ปล้อง",
  "+4 body segments (maximum body length).": "+4 ปล้อง (ความยาวลำตัวสูงสุด)",
  "Unlocks a RED homing-missile salvo — 5 missiles fire from the mouth sides, straight for a beat then homing.":
    "ปลดล็อกชุดจรวดนำวิถีสีแดง — 5 จรวดยิงจากด้านข้างของปาก พุ่งตรงชั่วครู่แล้วนำวิถี",
  "+5 missiles per salvo (10 total).": "+5 จรวดต่อชุด (รวม 10)",
  "+5 missiles per salvo (15 total).": "+5 จรวดต่อชุด (รวม 15)",
  "+5 missiles per salvo (20 — the maximum).": "+5 จรวดต่อชุด (รวม 20 — สูงสุด)",
  "The maw beam (main + every split) does +15% damage.":
    "ลำแสงปาก (ลำหลัก + ทุกลำที่แตก) สร้างความเสียหาย +15%",
  "+15% maw-beam damage.": "ความเสียหายลำแสงปาก +15%",
  "The maw beam's big + fan phases last +20% longer.":
    "ช่วงลำใหญ่ + ช่วงพัดของลำแสงปากนานขึ้น +20%",
  "+20% maw-beam duration.": "ระยะเวลาลำแสงปาก +20%",
  "The worm slithers +15% faster. Buyable anywhere — no mechanical yard needed.":
    "หนอนเลื้อยเร็วขึ้น +15% ซื้อได้ทุกที่ — ไม่ต้องใช้อู่ซ่อม",
  "+15% worm speed (no mechanical yard needed).": "ความเร็วหนอน +15% (ไม่ต้องใช้อู่ซ่อม)",
  "Each red missile that hits a target has a 10% chance to split into 1 branch missile that finds a new target.":
    "จรวดสีแดงแต่ละลูกที่โดนเป้าหมายมีโอกาส 10% ที่จะแตกออกเป็นจรวดแยก 1 ลูกที่หาเป้าหมายใหม่",
  "+5% split chance and +2 branch missiles.": "+5% โอกาสแตกตัว และ +2 จรวดแยก",
  "+5% split chance (20% max) and +2 branch missiles (5 max).":
    "+5% โอกาสแตกตัว (สูงสุด 20%) และ +2 จรวดแยก (สูงสุด 5)",
  "Each missile that hits a target has a 10% chance to split into 1 branch missile that finds a new target.":
    "จรวดแต่ละลูกที่โดนเป้าหมายมีโอกาส 10% ที่จะแตกออกเป็นจรวดแยก 1 ลูกที่หาเป้าหมายใหม่",

  // --- boss / worm UI + dialog ---
  "EATER OF WORLDS DEFEATED": "ปราบผู้กลืนกินโลกได้แล้ว",
  EXP: "ค่าประสบการณ์",
  "Salvage recovered": "ของที่กู้คืนได้",
  "No salvage recovered this time.": "ครั้งนี้ไม่ได้ของกู้คืน",
  Claim: "รับ",
  "Charge and fire the maw beam (splits into a fan)": "ชาร์จแล้วยิงลำแสงปาก (แตกออกเป็นรูปพัด)",
  "Launch the red homing-missile salvo": "ยิงชุดจรวดนำวิถีสีแดง",
  "The Eater of Worlds": "ผู้กลืนกินโลก",
  "Tap an upgrade for details · reach Mk II to unlock drones, then push on to Mk III":
    "แตะที่อัพเกรดเพื่อดูรายละเอียด · ไปให้ถึง Mk II เพื่อปลดล็อกโดรน แล้วไปต่อที่ Mk III",
  Milestone: "หมุดหมาย",
  Confirm: "ยืนยัน",
  "Locked — you chose the other path.": "ล็อกอยู่ — คุณเลือกอีกเส้นทางไปแล้ว",
  Requires: "ต้องมี",
  "🔧 Dock at a mechanical yard to buy.": "🔧 จอดที่อู่ซ่อมเพื่อซื้อ",
  "Not enough resources yet.": "ทรัพยากรยังไม่พอ",
  "Who dares disturb my slumber…": "ผู้ใดกล้ารบกวนการหลับใหลของข้า…",
  "Captain — that is no ordinary world. Something ancient just woke. Weapons hot!":
    "กัปตัน — นั่นไม่ใช่โลกธรรมดา บางสิ่งโบราณเพิ่งตื่นขึ้น เตรียมอาวุธ!",

  // --- Eater-of-Worlds part items ---
  "Eater of Worlds — Head": "ผู้กลืนกินโลก — หัว",
  "Eater of Worlds — Segment": "ผู้กลืนกินโลก — ปล้อง",
  "Eater of Worlds — Tail": "ผู้กลืนกินโลก — หาง",
  "Eater's Core": "แกนผู้กลืนกิน",
  "Trophy from slaying the Eater of Worlds (5% drop). Reserved for a future Mk VII refit.":
    "ถ้วยรางวัลจากการสังหารผู้กลืนกินโลก (ดรอป 5%) เก็บไว้สำหรับการอัพเกรด Mk VII ในอนาคต",
  "A segment of the Eater of Worlds (20% drop). Reserved for a future Mk VII refit.":
    "ปล้องของผู้กลืนกินโลก (ดรอป 20%) เก็บไว้สำหรับการอัพเกรด Mk VII ในอนาคต",
  "The Eater of Worlds' tail (10% drop). Reserved for a future Mk VII refit.":
    "หางของผู้กลืนกินโลก (ดรอป 10%) เก็บไว้สำหรับการอัพเกรด Mk VII ในอนาคต",
  "The Eater of Worlds' beating heart (1% drop). Reserved for a future Mk VII refit.":
    "หัวใจที่เต้นของผู้กลืนกินโลก (ดรอป 1%) เก็บไว้สำหรับการอัพเกรด Mk VII ในอนาคต",

  // --- Mk VIII ---
  "Mk VIII · Mechanical Eater of Worlds": "Mk VIII · ผู้กลืนกินโลกกลไก",
  "SECRET evolution of the Eater of Worlds — a mechanical worm with a tougher hull, a stronger maw beam, and +4 body segments. Refit off Mk VII.":
    "วิวัฒนาการลับของผู้กลืนกินโลก — หนอนกลไกที่มีเกราะแข็งแกร่งขึ้น ลำแสงปากทรงพลังขึ้น และ +4 ปล้อง อัพเกรดต่อจาก Mk VII",

  // --- Time & Space Rift (Mk VIII ability) ---
  "Time & Space Rift": "รอยแยกกาลอวกาศ",
  "SECRET Mk VIII ability: arm it, then tap the minimap. A sweeping laser carves a rift open (damaging foes + mining rocks); the worm dives through and re-emerges at the tapped spot.":
    "ความสามารถลับ Mk VIII: เปิดใช้แล้วแตะมินิแมป ลำแสงกวาดจะเปิดรอยแยก (สร้างความเสียหายต่อศัตรู + ขุดหิน) หนอนจะพุ่งผ่านและโผล่ออกมาที่จุดที่แตะ",
  "Time & Space Rift — arm, then tap the minimap to teleport":
    "รอยแยกกาลอวกาศ — เปิดใช้ แล้วแตะมินิแมปเพื่อวาร์ป",

  // --- Maelstrom Coil (Mk VIII ability) ---
  "Maelstrom Coil": "ขดวังวน",
  "SECRET Mk VIII ability: coil the worm into a spinning maelstrom — every segment fires a sweeping laser (½ the maw beam) while a 700-HP shield bubble covers the coil and sears anything inside. Rooted for ~3s.":
    "ความสามารถลับ Mk VIII: ขดหนอนเป็นวังวนหมุน — ทุกปล้องยิงเลเซอร์กวาด (½ ของลำแสงปาก) พร้อมโล่ฟองพลัง 700 HP ครอบคลุมทั้งขดและเผาทุกสิ่งที่อยู่ข้างใน หยุดนิ่งราว 3 วินาที",
  "Maelstrom Coil — curl up: every segment sweeps a laser + a shield bubble":
    "ขดวังวน — ขดตัว: ทุกปล้องกวาดเลเซอร์ + โล่ฟองพลัง",

  // --- Aria: deeper-space (jump 5) dialogue ---
  "Commander — the drive just carried us into a deeper stratum of space.":
    "ผู้บัญชาการ — ไดรฟ์เพิ่งพาเราเข้าสู่ห้วงอวกาศที่ลึกลงไปอีกชั้น",
  "The gathering grounds out here are far wider and the fields much richer — more ore, more room to run.":
    "พื้นที่เก็บเกี่ยวตรงนี้กว้างกว่ามาก และแหล่งแร่ก็อุดมสมบูรณ์กว่าเดิม — แร่มากขึ้น พื้นที่ให้วิ่งมากขึ้น",
  "But the deeper we go, the bolder the raiders. Expect more company. Stay sharp.":
    "แต่ยิ่งลึก โจรก็ยิ่งกล้า เตรียมรับมือกับศัตรูที่มากขึ้น ระวังตัวไว้",
};
